/* eslint-disable react/react-in-jsx-scope */
import { createContext, useState, useRef, useEffect } from 'react';

import rosetta from 'rosetta';

import { defaultLanguage } from '../language.config';

const i18n = rosetta();

export const I18nContext = createContext();

// default language
i18n.locale(defaultLanguage);

// eslint-disable-next-line react/prop-types
export default function I18n({ children, locale, lngDict, pageId }) {
  const activeLocaleRef = useRef(locale || defaultLanguage);
  const [, setTick] = useState(0);
  const firstRender = useRef(true);
  const [page, setPage] = useState('');

  const i18nWrapper = {
    activeLocale: activeLocaleRef.current,
    t: (...args) => i18n.t(...args),
    locale: (l, dict) => {
      i18n.locale(l);
      activeLocaleRef.current = l;
      if (dict) {
        i18n.set(l, dict);
      }
      // force rerender to update view
      setTick((tick) => tick + 1);
    }
  };

  if (locale && page !== pageId) {
    i18nWrapper.locale(locale, lngDict);
    setPage(pageId);
  }

  // for initial SSR render

  if (page !== pageId && firstRender.current === true) {
    if (locale) {
      firstRender.current = false;
      i18nWrapper.locale(locale, lngDict);
    }
  }

  // when locale is updated
  useEffect(() => {
    if (locale) {
      i18nWrapper.locale(locale, lngDict);
    }
  }, [lngDict, locale]);

  return (
    <I18nContext.Provider value={i18nWrapper}>{children}</I18nContext.Provider>
  );
}
